import { useTranslation } from 'next-i18next';
import useMoneyFormat from '@/hooks/useMoneyFormat';

export default function useTermsFormat(
  key: string,
  n: string | number | boolean | null | undefined,
  currency: string,
) {
  const { i18n, t } = useTranslation('markets');
  const FORMATS = {
    name: (val: string) => val,
    action_type: (val: string) => t(`markets.detailView.terms.${val}` as const).toString().toUpperCase(),
    share_price: (val: number, cur?: string) => useMoneyFormat(val, i18n.language, cur!, 'currency', 'symbol', 0, 2),
    voting_rights: (val: boolean | null) => (val === null ? '-' : val),
    n_of_securities: (val: number) => useMoneyFormat(val),
    o_n_of_securities: (val: number) => useMoneyFormat(val),
    premoney_valuation: (val: number, cur?: string) => useMoneyFormat(val, i18n.language, cur!, 'currency', 'symbol', 0, 2),
    valuation_premoney: (val: number, cur?: string) => useMoneyFormat(val, i18n.language, cur!, 'currency', 'symbol', 0, 2),
    datetime_maturity: (val: string) => new Date(val).toLocaleDateString(i18n.language, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }), // DateFormat
    term_length: (val: string | number) => useMoneyFormat(val),
    valuation_cap: (val: number, cur: string) => useMoneyFormat(val, i18n.language, cur!, 'currency', 'symbol', 0, 2),
    liquidity_event: (val: string | number) => useMoneyFormat(val),
    discount_rate: (val: number) => `${useMoneyFormat(val)}%`,
    interest_rate: (val: number) => `${useMoneyFormat(val)}%`,
    interest_rate_cap: (val: number) => useMoneyFormat(val),
    amortization: (val: string|null) => (val === null ? '-' : val),
    deferred_date: (val: string|null) => (val === null ? '-' : val),
    disbursement: (val: string) => val, // 'QUATERLY'
    conversion_ratio: (val: string|null) => (val === null ? '-' : val),
    revenue_percentage: (val: number) => `${useMoneyFormat(val)}%`,
    repayment_cap: (val: number) => useMoneyFormat(val),
    repayment_schedule: (val: string) => val, // 'QUATERLY'
  };
  return FORMATS[key](n, currency);
}
